import * as React from 'react';
import { ActionButton, InfoModal, Media, Subtitle, Title, VideoSrc } from './InfoModal';

export interface InfoModalWrapperProps {
    title: string;
    subtitle: string;
    videoSrc?: VideoSrc[];
    imgSrc?: string;
    actionButtonText?: string;
    elementToFocusOnClose?: React.RefObject<any>;
    onOverlayClick?: () => void;
    onClick: () => void;
}

export const InfoModalWrapper = (props: InfoModalWrapperProps) => {
    const {
        title,
        subtitle,
        elementToFocusOnClose,
        actionButtonText,
        videoSrc,
        imgSrc,
        onOverlayClick,
        onClick,
    } = props;
    return (
        <InfoModal onOverlayClick={onOverlayClick} elementToFocusOnClose={elementToFocusOnClose}>
            <Media type="Media" videoSrc={videoSrc} imageSrc={imgSrc} />
            <Title type="Title">{title}</Title>
            <Subtitle type="Subtitle">{subtitle}</Subtitle>
            <ActionButton type="ActionButton" onClick={onClick} text={actionButtonText} />
        </InfoModal>
    );
};
